import React, { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom"; // Assuming you're using React Router
import {
  Container,
  Row,
  Col,
  Button,
  Breadcrumb,
  Image,
  Form,
  Spinner,
  Tabs,
  Tab,
} from "react-bootstrap"; // Assuming you're using Bootstrap for styling
import DefaultProduct from "../../assets/images/default-product.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faHeart as faHeartOutline } from "@fortawesome/free-regular-svg-icons";
// import { faHeart } from "@fortawesome/free-solid-svg-icons";
import { getStyles } from "./ProductDetails.style";
import Section from "../../Components/Section/Section";
import defaultAvatar from "../../assets/images/User.png";
import {
  Add_To_Cart,
  Product_Details_Rating,
  Remove_From_Cart,
  Single_Product_Details,
  Update_Cart,
  View_Cart,
  Delivery_Method,
} from "../../Api";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../Redux/Store/Store";
import { base_url } from "../../Api/ApiConst";
import { VIEW_CART } from "../../Redux/Cart";
import { toast } from "react-toastify";
import {
  AddToWishList,
  handleRemoveFromWishlist,
} from "../../Utils/wishListUtils";
import ReactImageMagnify from "react-image-magnify";

import PeopleAlsoBought from "../../Components/PeopleAlsoBought/PeopleAlsoBought";
import { getQuantity, handleShowInventoryLabel } from "../../Utils/cartUtils";
import { STORAGE_CONSTANTS } from "../../shared/Constants/Constants";
import Carousel from "react-multi-carousel";
import {
  faHeart,
  faAngleLeft,
  faAngleRight,
} from "@fortawesome/free-solid-svg-icons";
import { useTranslation } from "react-i18next";
import { SET_SELECTED_STORE_SUBCATEGORY } from "../../Redux/User";
import { Rating } from "react-simple-star-rating";
import NoDataFound from "../../Components/NoDataFound/NoDataFound";
import Loading from "./components/Loading";
import { selected_pickup } from "../../Redux/Cart";
import { AxiosError } from "axios";
import { useRef } from "react";
import { Modal } from "react-bootstrap";
import LoginPhoneNumber from "../../Components/LoginModal";
import VerifyDetails from "../../Components/LoginModal/VerifyDetailsModal";
import divWithClassName from "react-bootstrap/esm/divWithClassName";

const responsive = {
  superLargeDesktop: {
    breakpoint: { max: 4000, min: 3000 },
    items: 1,
  },
  largeDesktop: {
    breakpoint: { max: 3000, min: 1901 },
    items: 1,
  },
  desktop: {
    breakpoint: { max: 1900, min: 1024 },
    items: 1,
  },
  tablet: {
    breakpoint: { max: 1024, min: 464 },
    items: 1,
  },
  mobile: {
    breakpoint: { max: 464, min: 0 },
    items: 1,
  },
};
const anonymousUser = "Anonymous User";

const ProductDetails: React.FC = () => {
  const { t, i18n } = useTranslation();

  const [isMobile, setIsMobile] = useState(window.innerWidth <= 767);
  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 767);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const styles = getStyles(isMobile);
  // const [selectedOption, setSelectedOption] = useState<string>("delivery");
  const [selectedOption, setSelectedOption] = useState<string>("");
  const [product, setProduct] = useState<any>({});
  const [products, setProducts] = useState<any>({});
  const [loading, setLoading] = useState<boolean>(true);
  const [state, setState] = useState<boolean>();
  const [userToken, setUserToken] = React.useState<string | null>("");
  const [quantity, setQuantity] = useState<number>(1);
  const [currency, setCurrency] = useState("NPR");
  const [reviews, setReviews] = useState<any>("");
  const { slug } = useParams(); // Get slug from URL
  const carouselRef = useRef<any>(null);
  // login modal states
  const [loginFeatureModal, setLoginFeatureModal] = useState(false);
  const [verifyDetailsModal, setVerifyDetailsModal] = useState(false);
  const [productId, setProductId] = useState<any>(null);

  const product_id = useSelector(
    (state: RootState) => state.productId.selected_product_id,
  );

  const wishlist: any = useSelector(
    (state: RootState) => state.User.productIdInWishList,
  );
  const [orderId, setOrderId] = useState<any>("");
  const userLatitude = useSelector(
    (state: RootState) => state.Location.selected_latitude,
  );
  const userLongitude = useSelector(
    (state: RootState) => state.Location.selected_longitude,
  );
  const languageId: any = useSelector((state: RootState) => state.lan);
  const cartOrderId = useSelector((state: RootState) => state.Cart.View_Cart);
  const [prodQuantity, setProdQuantity] = useState<number>(1);

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleOptionChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    // const updatedPickupOptions = selectedPickupOptions.map((item: any) => {
    //   if (item.id === selectedStoreId) {
    //     return { id: item.id, selectedOption: e.target.value };
    //   }
    //   return item;
    // });
    setSelectedOption(event.target.value);
    DeliveryMethod(
      orderId,
      product.product_details.product_vendor_store.id,
      event.target.value,
    );
    // dispatch(selected_pickup(updatedPickupOptions));
  };

  const DeliveryMethod = async (
    orderId: any,
    storeId: any,
    selectedDeliveryMethod: any,
  ) => {
    try {
      const response = await Delivery_Method(
        orderId,
        storeId,
        selectedDeliveryMethod,
      );
      if (response && response.status === 200) {
      } else {
        console.log("Error");
      }
    } catch (error: unknown) {
      // toast.error(err.response.error?.data as any)
      // console.log("Error", error.response.data.error);
      if (error instanceof AxiosError) {
        toast.error(
          error.response?.data?.error ||
          error.response?.data?.delivery_method?.[0] ||
          error?.response?.data?.non_field_errors?.[0],
        );
      } else {
        console.log("Unexpected error", error);
      }
    }
  };
  const [expanded, setExpanded] = useState(false);

  const outOfstock = useSelector((state: RootState) => state.offer.OutOfStock);
  const isOutOfStock =
  Number(product?.product_details?.available ?? 0) <= 0;
  const userPincode = useSelector((state: RootState) => state.Location.pincode);

  useEffect(() => {
    setUserToken(localStorage.getItem(STORAGE_CONSTANTS.USER_TOKEN));
    Cart_Details();
    window.scrollTo(0, 0);
  }, []);

  const update = () => { };
  const googleMapsApiKey = process.env.REACT_APP_GOOGLE_MAPS_API_KEY;

  const fetchStoreList = async () => {
    try {
      setLoading(true);
      let lat = userLatitude;
      let long = userLongitude;
      let pincode = userPincode;
      const identifier = slug || product_id;

      // If location details are missing, get the user's current location
      if (!lat || !long) {
        await new Promise((resolve, reject) => {
          navigator.geolocation.getCurrentPosition(
            (position) => {
              lat = position.coords.latitude;
              long = position.coords.longitude;
              // console.log(`User Location: lat=${lat}, long=${long}`);
              resolve(true);
            },
            (error) => {
              console.error("Error fetching user location:", error);
              reject(error);
            },
          );
        });
      }
      if (!pincode && lat && long) {
        const res = await fetch(
          `https://maps.googleapis.com/maps/api/geocode/json?latlng=${lat},${long}&key=${googleMapsApiKey}`,
        );
        const data = await res.json();

        if (data.status === "OK" && data.results.length > 0) {
          const addressComponents = data.results[0].address_components;
          const pincodeObj = addressComponents.find((comp: any) =>
            comp.types.includes("postal_code"),
          );
          pincode = pincodeObj ? pincodeObj.long_name : "";
        }

        // console.log(`Detected Pincode: ${pincode}`);
      }
      const response = await Single_Product_Details(
        identifier,
        lat,
        long,
        pincode,
      );
      if (response && response.status === 200) {
        setProduct(response.data);
        setProdQuantity(
          getQuantity(
            response.data?.product_details?.product_vendor_store?.id,
            response.data?.product_details?.id,
          ),
        );
      } else {
        console.log("Error fetching Store Product Details");
      }
    } catch (error) {
      console.log("Error fetching Store Product Details", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (slug || product_id) {
      fetchStoreList();
      update();
      handleReviews();
    }
  }, [slug, product_id]);
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const handleCart = (id: any, minimum_qty: any) => {
    const addToCart = async () => {
      try {
        const response = await Add_To_Cart(id, currency, minimum_qty);
        if (response && response.status === 200) {
          if (response.data.status === false) {
            toast.error("Product is Out of stock!");
          } else {
            localStorage.setItem(
              STORAGE_CONSTANTS.ORDER_ID,
              response?.data?.order_id,
            );
            toast.success(response["data"]["message"]);
            const Cartresponse = await View_Cart();
            if (Cartresponse && Cartresponse.status === 200) {
              // console.log(Cartresponse.data, "kkkkkkkkkkkk");
              setOrderId(Cartresponse?.data?.cart_details?.order.id);
              dispatch(VIEW_CART(Cartresponse.data));
              setProdQuantity(
                getQuantity(
                  product?.product_details?.product_vendor_store?.id,
                  product?.product_details?.id,
                ),
              );
            }
          }
        } else {
          toast.error(response["data"]["message"]);
        }
      } catch (error: any) {
        console.log("Error occurred:", error.response.data.error_message);
        // handled unauthorized status ie: 401
        if (error.status === 401) {
          toast.error("Please log in to add items to your cart.");
        }
      }
    };
    addToCart();
  };

  const Cart_Details = async () => {
    try {
      const response = await View_Cart();
      if (response && response.status === 200) {
        if (response.data.error) {
          return toast.error(response.data.error);
        }
        // An empty cart has no cart_details (and always sets error above)
        if (!response.data.cart_details) return;
        setProducts(response.data.cart_details.order.order_list);
        setOrderId(response.data.cart_details.order.id);
      } else {
        console.log("Error fetching Cart details");
      }
    } catch (error: any) {
      console.log("Error fetching Cart details", error);
    }
  };

  const handleReviews = async () => {
    try {
      const response = await Product_Details_Rating(product_id);
      if (response && response.status === 200) {
        if (response.data.status === true) {
          setReviews(response.data.product_rating_list);
        } else {
          setReviews("");
        }
      } else {
        console.log("Error fetching Cart details");
      }
    } catch (error: any) {
      console.log("Error fetching Cart details", error);
    }
  };

  const incrementQuantity = (id: any) => {
    setProdQuantity((prev: any) => prev + 1);
    const Update_product = async () => {
      try {
        const response = await Update_Cart(
          currency,
          prodQuantity + 1,
          id,
          orderId,
        );
        if (response && response.status === 200) {
          const Cartresponse = await View_Cart();
          if (Cartresponse && Cartresponse.status === 200) {
            dispatch(VIEW_CART(Cartresponse.data));
          }
          setState(true);
          Cart_Details();
          if (response?.data?.error) {
            toast.error(response?.data?.error);
          } else {
            toast.success(response["data"]["message"]);
          }
        } else {
          console.log("Error fetching Cart details");
        }
      } catch (error: any) {
        toast.error(error.response.data.message);
      }
    };
    Update_product();
  };

  const decrementQuantity = async (id: any, minimum_qty: any) => {
    setProdQuantity((prev: any) => prev - 1);
    if (prodQuantity > minimum_qty) {
      const Update_product = async () => {
        try {
          const response = await Update_Cart(
            currency,
            prodQuantity - 1,
            id,
            orderId,
          );
          if (response && response.status === 200) {
            const Cartresponse = await View_Cart();
            if (Cartresponse && Cartresponse.status === 200) {
              dispatch(VIEW_CART(Cartresponse.data));
            }
            setState(true);
            Cart_Details();
            toast.success(response["data"]["message"]);
          } else {
            console.log("Error fetching Cart details");
          }
        } catch (error: any) {
          console.log("Error fetching Cart details", error);
          toast.error(error.response.data.message);
        }
      };
      Update_product();
    } else if (prodQuantity == minimum_qty) {
      try {
        const response = await Remove_From_Cart(currency, id, orderId);
        if (response && response.status === 200) {
          setState(false);
          Cart_Details();
          toast.success(response["data"]["message"]);
        } else {
          console.log("Error fetching Cart details");
        }
      } catch (error: any) {
        console.log("Error fetching Cart details", error);
        toast.error(error.response.data.message);
      }
    }
  };

  var description =
    product?.product_details?.language_data.length === 0
      ? product?.product_details?.product_description
      : languageId === "ne"
        ? product?.product_details?.language_data[0]?.product_description
        : product?.product_details?.product_description;
  const countLines = (text: string | undefined) => {
    const lines = text ? Math.ceil(text.length / 60) : 0; // Check if text is defined before accessing its length property
    return lines;
  };

  const showViewMoreButton = description && description.length > 300;

  const handleToggle = () => {
    setExpanded(!expanded);
  };

const getProductImageUrl = (image?: string | null): string => {
  if (!image || typeof image !== "string" || !image.trim()) {
    return DefaultProduct;
  }

  const trimmedImage = image.trim();

  if (/^https?:\/\//i.test(trimmedImage)) {
    return trimmedImage;
  }

  return `${base_url.replace(/\/+$/, "")}/${trimmedImage.replace(/^\/+/, "")}`;
};

  const renderCarouselItems = () => {
  const images = [
    product?.product_details?.product_image,
    product?.product_details?.additional_image_1,
    product?.product_details?.additional_image_2,
  ].filter(
    (image): image is string =>
      typeof image === "string" && image.trim().length > 0
  );

  const imagesToRender =
    images.length > 0 ? images : [DefaultProduct];

  return imagesToRender.map((image, index) => {
    const imageUrl = getProductImageUrl(image);

    return (
      <div
        key={`${image}-${index}`}
        style={{
          width: 500,
          height: 500,
          margin: "auto",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <ReactImageMagnify
          {...{
            smallImage: {
              alt: "Product Image",
              isFluidWidth: false,
              width: 500,
              height: 500,
              src: imageUrl,

              onError: (
                e: React.SyntheticEvent<HTMLImageElement>
              ) => {
                e.currentTarget.onerror = null;
                e.currentTarget.src = DefaultProduct;
              },
            },

            largeImage: {
              src: imageUrl,
              width: 1000,
              height: 1000,

              onError: (
                e: React.SyntheticEvent<HTMLImageElement>
              ) => {
                e.currentTarget.onerror = null;
                e.currentTarget.src = DefaultProduct;
              },
            },

            enlargedImagePosition: "over",

            enlargedImageContainerStyle: {
              zIndex: 1500,
              background: "#fff",
              boxShadow: "0 2px 16px rgba(0,0,0,0.15)",
              marginLeft: 16,
            },

            enlargedImageContainerDimensions: {
              width: "100%",
              height: "100%",
            },

            isHintEnabled: true,
            shouldUsePositiveSpaceLens: true,
          }}
        />
      </div>
    );
  });
};

  const renderThumbnails = () => {
  const images = [
    product?.product_details?.product_image,
    product?.product_details?.additional_image_1,
    product?.product_details?.additional_image_2,
  ].filter((image): image is string => Boolean(image?.trim()));

  const imagesToRender =
    images.length > 0 ? images : [DefaultProduct];

  return imagesToRender.map((image, index) => {
    const imageUrl = getProductImageUrl(image);

    return (
      <div
        key={index}
        className="thumbnail bg-red"
        onClick={() => {
          handleThumbnailClick(index);
        }}
      >
        <Image
          src={imageUrl}
          alt={`Thumbnail Image ${index + 1}`}
          style={{
            cursor: "pointer",
            border:
              activeIndex === index ? "2px solid #808080" : "none",
          }}
          onError={(e) => {
            e.currentTarget.onerror = null;
            e.currentTarget.src = DefaultProduct;
          }}
        />
      </div>
    );
  });
};

  const handleThumbnailClick = (index: number) => {
    // alert(index)
    setActiveIndex(index);
    carouselRef.current?.goToSlide(index);
  };

  const handleClick = (item: any) => {
    localStorage.setItem(
      STORAGE_CONSTANTS.SHOP_ID,
      item?.product_details?.product_vendor_store?.id,
    );
    dispatch(
      SET_SELECTED_STORE_SUBCATEGORY(
        item?.product_details?.product_subcategory?.id,
      ),
    );
    let languageData = undefined;
    if (
      item?.product_details?.product_vendor_store?.language_data &&
      item?.product_details?.product_vendor_store?.language_data?.length > 0
    ) {
      languageData =
        item?.product_details?.product_vendor_store?.language_data[0]
          ?.store_name;
    }
    const state = {
      store_name: item?.product_details?.product_vendor_store?.store_name,
      store_type: item?.product_details?.product_vendor_store?.store_type,
      distance_in_km:
        item?.product_details?.product_vendor_store?.distance_in_km,
      language_data: languageData,
      store_rating: item?.product_details?.product_vendor_store?.store_rating,
      store_logo: item?.product_details?.product_vendor_store?.logo,
      storeId: item?.product_details?.product_vendor_store?.id,
    };
    navigate("/store", { state: state });
  };

  const [activeIndex, setActiveIndex] = useState(0);
  const renderProductDetails = () => {
    return (
      <div>
        <p
          style={{ ...styles.tax, whiteSpace: "pre-line" }}
          className={expanded ? "expanded" : ""}
        >
          {expanded ? description : description?.slice(0, 400)}{" "}
          {/* Add a null check for description */}{" "}
          {showViewMoreButton && (
            <Button
              className="p-0"
              variant="link"
              onClick={handleToggle}
              style={styles.view}
            >
              {expanded
                ? t("productDetails.viewLess")
                : t("productDetails.viewMore")}
            </Button>
          )}
        </p>
      </div>
    );
  };

  const renderReviews = () => {
    return (
      <div>
        {reviews.length === 0 ? (
          <NoDataFound title="No Reviews Yet" />
        ) : (
          reviews.length > 0 &&
          reviews.map((review: any, index: any) => (
            <div key={index} className="review">
              <div className="review-header">
                <img
                  src={review.profileImage || defaultAvatar}
                  alt={review.customer_name || anonymousUser}
                  className="profile-image"
                />
                <div>
                  <p className="name mb-0">
                    {review.customer_name || anonymousUser}
                  </p>
                  <p className="rating mb-0">
                    <Rating initialValue={review.rate} size={20} />
                  </p>
                  <p className="comment">{review.client_comment}</p>
                </div>
              </div>
            </div>
          ))
        )}
      </div>
    );
  };

  return (
    <>
      <Section className="productDetails">
        <Container>
          {loading && <Loading />}
          {!loading && product.length !== 0 && (
            <Row className="align-items-stretch" style={styles.productRow}>
              <Col
                md={6}
                style={{
                  ...styles.productImagesWrap,
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                }}
              >
                <FontAwesomeIcon
                  icon={
                    wishlist.includes(product?.product_details?.id)
                      ? (faHeart as any)
                      : (faHeartOutline as any)
                  }
                  onClick={() => {
                    if (!userToken) {
                      toast.error("Login to add products to wishlist");
                      setLoginFeatureModal(true);
                      setProductId(product?.id);
                      return;
                    }

                    if (wishlist.includes(product?.product_details?.id)) {
                      handleRemoveFromWishlist(product?.product_details?.id);
                    } else {
                      AddToWishList(product?.product_details?.id);
                    }
                  }}
                  style={styles.wishlistIcon}
                  className="mx-2 hide-lg"
                />
                <Carousel
                  ref={carouselRef}
                  responsive={responsive}
                  ssr={true}
                  itemClass="image-item"
                  customTransition="all .5"
                  transitionDuration={500}
                  containerClass="carousel-container"
                  additionalTransfrom={0}
                  showDots={false}
                  renderDotsOutside={false}
                  arrows={true}
                  infinite={false}
                  draggable={false}
                  swipeable={true}
                  autoPlay={false}
                  centerMode={false}
                  dotListClass=""
                  sliderClass=""
                  slidesToSlide={1}
                  keyBoardControl={true}
                  minimumTouchDrag={80}
                  partialVisible={false}
                  beforeChange={(nextSlide) => setActiveIndex(nextSlide)}
                  customLeftArrow={
                    <div className="custom-arrow left">
                      <FontAwesomeIcon icon={faAngleLeft as any} />
                    </div>
                  }
                  customRightArrow={
                    <div className="custom-arrow right">
                      <FontAwesomeIcon icon={faAngleRight as any} />
                    </div>
                  }
                >
                  {renderCarouselItems()}
                </Carousel>
                <div
                  className="thumbnail-container mt-3"
                  style={{ display: "flex", justifyContent: "center" }}
                >
                  {renderThumbnails()}
                </div>
              </Col>

              <Col
                md={6}
                style={{
                  ...styles.productInfoWrap,
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                }}
              >
                <Breadcrumb>
                  <Breadcrumb.Item>
                    <Link to="/">{t("commonFormLabels.home")}</Link>
                  </Breadcrumb.Item>

                  <Breadcrumb.Item>
                    <p onClick={() => handleClick(product)} className="mb-0">
                      {" "}
                      {
                        product?.product_details?.product_vendor_store
                          ?.store_name
                      }
                    </p>{" "}
                  </Breadcrumb.Item>
                  <Breadcrumb.Item>
                    {product?.product_details?.product_subcategory?.name}
                  </Breadcrumb.Item>
                  <Breadcrumb.Item active>
                    {product?.product_details?.product_name}
                  </Breadcrumb.Item>
                </Breadcrumb>
                <h2 style={styles.productName}>
                  {product?.product_details?.language_data.length === 0
                    ? product?.product_details?.product_name
                    : languageId === "ne"
                      ? product?.product_details?.language_data[0].product_name
                      : product?.product_details?.product_name}
                </h2>
                <hr style={{ backgroundColor: "#D9D9D9" }} className="mb-0" />

                {product?.product_details?.current_price?.offer_type ===
                  "bogo" ? (
                  <div className="bogo-wrap mb-3">
                    {`Buy ${product?.product_details?.current_price.buy_quantity
                      }, get ${product?.product_details?.current_price.free_product
                        .length > 15
                        ? product?.product_details?.current_price.free_product.substring(
                          0,
                          15,
                        ) + "..."
                        : product?.product_details?.current_price.free_product
                      } ${product?.product_details?.current_price.free_quantity
                      } Free`}
                  </div>
                ) : (
                  <div style={{ minHeight: 25 }}></div>
                )}
                <div className="d-flex align-items-center ">
                  <p style={styles.qty} className="mb-0">
                    {product?.product_details?.weight}{" "}
                    {product?.product_details?.unit_measure}
                  </p>
                  <div>
                    {product?.product_details?.brand && (
                      <h3
                        className="brandName mb-2 mx-2"
                        style={{ display: "inline", fontSize: 14 }}
                      >
                        {product.product_details?.brand}
                      </h3>
                    )}
                  </div>
                </div>
                <div style={styles.priceWrap}>
                  {product?.product_details?.current_price ? (
                    <span style={styles.offerPrice} className="offerPrice">
                      रु
                      {parseFloat(
                        product?.product_details?.current_price?.current_price,
                      ).toFixed(2)}
                    </span>
                  ) : (
                    <span style={styles.offerPrice} className="price">
                      रु
                      {parseFloat(product?.product_details?.price).toFixed(
                        2,
                      )}
                    </span>
                  )}
                  {product?.product_details?.current_price &&
                    product?.product_details?.current_price?.offer_type !==
                    "bogo" && (
                      <span style={styles.price} className="price">
                        रु{product?.product_details?.price}
                      </span>
                    )}

                  {product?.product_details?.current_price?.discount_val && (
                    <span style={styles.offer}>
                      {product?.product_details?.current_price?.discount_val}%
                      OFF
                    </span>
                  )}
                </div>
                <p style={styles.tax}>{t("productDetails.taxes")}

                </p>
                <div style={styles.radioWrap} className="mt-3 product-delivery">
                  <Form.Group>
                    <p className="fw-semibold mb-2">Delivery options</p>

                    <div className="row g-2">

                      {(product.product_details.product_vendor_store.store_type === "Pick and Delivery" ||
                        product.product_details.product_vendor_store.store_type === "PICK_AND_DELIVERY") && (
                          <div
                       className={`border rounded p-2 text-center cursor-pointer ${
                         selectedOption === "pickup"
                           ? "border-primary bg-light shadow-sm"
                           : ""
                       } ${isOutOfStock ? "delivery-option-disabled" : ""}`}
                       onClick={() => {
                         if (!isOutOfStock) {
                           handleOptionChange({
                             target: { value: "pickup" },
                           } as React.ChangeEvent<HTMLInputElement>);
                          }
                       }}
                          style={{                     
                             cursor: isOutOfStock ? "not-allowed" : "pointer",
                            opacity: isOutOfStock ? 0.5 : 1,
                             pointerEvents: isOutOfStock ? "none" : "auto",
                            }}
                      >
                       <small className="fw-semibold d-block">
                         Pickup
                       </small>
                      </div>
                        )}

                      {(product.product_details.product_vendor_store.store_type === "Pick and Delivery" ||
                        product.product_details.product_vendor_store.store_type === "PICK_AND_DELIVERY") && (
                          <div className="col-6">
                            <div
                             className={`border rounded p-2 text-center cursor-pointer ${
                               selectedOption === "delivery"
                                 ? "border-primary bg-light shadow-sm"
                                 : ""
                             } ${isOutOfStock ? "delivery-option-disabled" : ""}`}
                             onClick={() => {
                               if (!isOutOfStock) {
                                 handleOptionChange({
                                    target: { value: "delivery" },
                                  } as React.ChangeEvent<HTMLInputElement>);
                               }
                             }}
                              style={{
                                cursor: isOutOfStock ? "not-allowed" : "pointer",
                                opacity: isOutOfStock ? 0.5 : 1,
                                pointerEvents: isOutOfStock ? "none" : "auto",
                              }}
                            >
                              <small className="fw-semibold d-block">
                               Delivery
                              </small>
                            </div>
                          </div>
                        )}

                      {(product.product_details.product_vendor_store.store_type === "Only Delivery" ||
                        product.product_details.product_vendor_store.store_type === "ONLY_DELIVERY") && (
                          <div className="col-12">
                            <div
  className={`border rounded p-2 text-center cursor-pointer ${
    selectedOption === "delivery"
      ? "border-primary bg-light shadow-sm"
      : ""
  } ${isOutOfStock ? "delivery-option-disabled" : ""}`}
  onClick={() => {
    if (!isOutOfStock) {
      handleOptionChange({
        target: { value: "delivery" },
      } as React.ChangeEvent<HTMLInputElement>);
    }
  }}
  style={{
    cursor: isOutOfStock ? "not-allowed" : "pointer",
    opacity: isOutOfStock ? 0.5 : 1,
    pointerEvents: isOutOfStock ? "none" : "auto",
  }}
>
  <small className="fw-semibold d-block">
    Delivery Only
  </small>
</div>
                          </div>
                        )}

                      {(product.product_details.product_vendor_store.store_type !== "Pick and Delivery" &&
                        product.product_details.product_vendor_store.store_type !== "PICK_AND_DELIVERY" &&
                        product.product_details.product_vendor_store.store_type !== "Only Delivery" &&
                        product.product_details.product_vendor_store.store_type !== "ONLY_DELIVERY") && (
                          <div className="col-12">
                             <div
  className={`border rounded p-2 text-center cursor-pointer ${
    selectedOption === "delivery"
      ? "border-primary bg-light shadow-sm"
      : ""
  } ${isOutOfStock ? "delivery-option-disabled" : ""}`}
  onClick={() => {
    if (!isOutOfStock) {
      handleOptionChange({
        target: { value: "delivery" },
      } as React.ChangeEvent<HTMLInputElement>);
    }
  }}
  style={{
    cursor: isOutOfStock ? "not-allowed" : "pointer",
    opacity: isOutOfStock ? 0.5 : 1,
    pointerEvents: isOutOfStock ? "none" : "auto",
  }}
>
  <small className="fw-semibold d-block">
    Delivery Only
  </small>
</div>
                          </div>
                        )}

                    </div>
                  </Form.Group>

                  <FontAwesomeIcon
                    icon={
                      wishlist.includes(product?.product_details?.id)
                        ? (faHeart as any)
                        : (faHeartOutline as any)
                    }
                    // onClick={() => {
                    //   {
                    //     userToken
                    //       ? wishlist.includes(product?.product_details?.id)
                    //         ? handleRemoveFromWishlist(
                    //           product?.product_details?.id
                    //         )
                    //         : AddToWishList(product?.product_details?.id)
                    //       : toast.error("Login to add products to wishlist");
                    //   }
                    // }}
                    onClick={() => {
                      if (!userToken) {
                        toast.error("Login to add products to wishlist");
                        setLoginFeatureModal(true);
                        setProductId(product?.product_details?.id);
                        return;
                      }

                      if (wishlist.includes(product?.product_details?.id)) {
                        handleRemoveFromWishlist(product?.product_details?.id);
                      } else {
                        AddToWishList(product?.product_details?.id);
                      }
                    }}
                    style={styles.wishlistIcon}
                    className="mx-3 hide-xs mt-4"
                  />

                </div>
                <div className="d-flex align-items-center justify-content-start">
                  {getQuantity(
                    product?.product_details?.product_vendor_store?.id,
                    product?.product_details?.id,
                  ) > 0 && (
                      <div className="add-to-cart">
                        <button
                          className="quantity-button"
                          onClick={() =>
                            decrementQuantity(
                              product?.product_details?.id,
                              product?.product_details?.minimum_qty,
                            )
                          }
                        >
                          -
                        </button>
                        <span className="quantity">{prodQuantity}</span>
                        <button
                          className="quantity-button add"
                          onClick={() =>
                            incrementQuantity(product?.product_details?.id)
                          }
                          disabled={
                            product?.product_details?.maximum_qty == prodQuantity
                          }
                        >
                          +
                        </button>
                      </div>

                    )}
                </div>

                {isOutOfStock ? (
                  <div className="d-grid gap-2 mt-3">
                    <Button
                     style={styles.btnAdd}
                     size="lg"
                      disabled
                     className="btn-outOfStock"
                   >
                     {t("commonHeader.outOfStock")}
                   </Button>
                 </div>
                ) : (
                 getQuantity(
                    product?.product_details?.product_vendor_store?.id,
                   product?.product_details?.id,
                 ) <= 0 && (
                   <div className="d-flex gap-2 mt-3">
                     <Button
                       className="btnBlue flex-fill"
                       onClick={() =>
                         handleCart(
                           product?.product_details?.id,
                           product?.product_details?.minimum_qty
                         )
                       }
                     >
                       {t("productDetails.addToCart")}
                     </Button>
                   </div>
                 )
                )}
                {outOfstock.includes(product?.product_details?.id) ? (
                  ""
                ) : (
                  <div>
                    <p
                      style={{
                        color: "red",
                        fontSize: "small",
                      }}
                    >
                      {handleShowInventoryLabel(
                        product?.product_details?.minimum_qty,
                        product?.product_details?.maximum_qty,
                        product?.product_details?.available,
                        prodQuantity,
                      )}
                    </p>

                  </div>
                )}

                {getQuantity(
                  product?.product_details?.product_vendor_store?.id,
                  product?.product_details?.id,
                ) > 0 && (
                    <div className="add-to-cart">
                      <Button
                        className="btnBlue flex-fill"
                        onClick={() =>
                          navigate("/view-cart")
                        }
                      >
                        Proceed to Checkout
                      </Button>
                    </div>

                  )}
              </Col>
            </Row>
          )}
          {!loading && product.length !== 0 && (
            <Row className="my-5 productDetailsRow">
              <Col className="p-0">
                <Tabs defaultActiveKey="details" id="product-details-tabs">
                  <Tab
                    eventKey="details"
                    title={t("productDetails.productDetails")}
                    className="py-3"
                  >
                    {renderProductDetails()}
                  </Tab>
                  <Tab
                    eventKey="reviews"
                    title={t("userProfile.productReviews")}
                    className="py-3"
                  >
                    {renderReviews()}
                  </Tab>
                </Tabs>
              </Col>
            </Row>
          )}
        </Container>
      </Section>
      <Section
        style={{
          backgroundColor: "#F0F6FF",
          paddingTop: 30,
          paddingBottom: 30,
        }}
      >
        <Container>
          <Row>
            <PeopleAlsoBought />
          </Row>
        </Container>
      </Section>
      {/* modal for login flow */}
      <div>
        <Modal
          show={loginFeatureModal}
          onHide={() => setLoginFeatureModal(false)}
          centered
        >
          <Modal.Body>
            <LoginPhoneNumber
              setVerifyDetailsModal={setVerifyDetailsModal}
              setLoginFeatureModal={setLoginFeatureModal}
            />
          </Modal.Body>
        </Modal>
        <Modal
          show={verifyDetailsModal}
          onHide={() => setVerifyDetailsModal(false)}
          centered
        >
          <Modal.Body>
            <VerifyDetails
              setVerifyDetailsModal={setVerifyDetailsModal}
              productId={productId}
            />
          </Modal.Body>
        </Modal>
      </div>
    </>
  );
};

export default ProductDetails;
